import { TruckIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { ActiveDeliveries } from "../../components/active-deliveries";
import { PageLayout } from "../../components/layout";
import { usePermission } from "../../components/permission";

const useBreadcrumb = (t: (key: string) => string) => [
  { to: "/", label: t("common:breadcrumb.home") },
  { label: t("delivery:activePage.title") },
];

export function ActiveDeliveriesPage() {
  const { t } = useTranslation(["delivery", "common"]);
  const ORD_LIST = usePermission("ORD_DN_DRAFT_LIST");
  const breadcrumbs = useBreadcrumb(t);

  return (
    <PageLayout
      icon={<TruckIcon size={22} />}
      title={t("delivery:activePage.title")}
      subTitle={t("delivery:activePage.subtitle")}
      breadcrumb={breadcrumbs}
    >
      {ORD_LIST.hasAccess ? <ActiveDeliveries /> : ORD_LIST.accessDenied()}
    </PageLayout>
  );
}
